// extracted by mini-css-extract-plugin
export var childrenContainer = "_bq-0";
export var virtualScrollArea = "_bq-1";